import { Tooltip } from '@ets/design-system';
import MathComponent from './MathComponent';

type MathMLProps = {
  testId: string;
  tooltip?: string;
  mml?: string;
};

const MathML = ({ mml, tooltip, testId }: MathMLProps) => {
  if (tooltip) {
    return (
      <Tooltip content={tooltip} testId={testId}>
        <div>
          <MathComponent mml={mml} testId={testId} />
        </div>
      </Tooltip>
    );
  }
  return <MathComponent mml={mml} testId={testId} />;
};

export default MathML;
